var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pgb"},[_vm._l((_vm.boundRoles),function(role,i){return [_c('nuxt-link',{key:role.id,attrs:{"to":role.detailLocation}},[_vm._v("\n      "+_vm._s(role.label)+"\n    ")]),_vm._v(" "),(i + 1 < _vm.boundRoles.length)?[_vm._v("\n      , \n    ")]:_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }